export default __webpack_public_path__ + "static/media/Deskera_Books.e545f786.svg";